import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-en",
  "use": "icon-en-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"icon-en\"><path d=\"M10.023 8.768l-2.049 5.575h4.154l-2.03-5.575h-.075zm7.92-5.925H2.16c-1.182 0-2.16.96-2.16 2.16V20.84C0 22.04.96 23 2.16 23h15.782c1.182 0 2.16-.96 2.16-2.16V5.002c0-1.2-.96-2.16-2.16-2.16zm-4.099 16.244L12.7 15.912H7.402L6.24 19.087H4.246L8.99 6.756h2.14l4.745 12.33h-2.03zM22.114 0H4.43a.898.898 0 0 0-.886.886c0 .48.406.886.886.886h16.798v16.872c0 .48.406.886.886.886s.886-.406.886-.886V.886A.898.898 0 0 0 22.114 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol